import { SxProps, Theme } from '@mui/material';
import MuiCheckbox, { checkboxClasses } from '@mui/material/Checkbox';
import { useCallback } from 'react';

interface CheckboxProps {
  ariaLabel?: string;
  color?: keyof Theme['brandV2']['colors'];
  isChecked?: boolean;
  isDisabled?: boolean;
  isIntermediate?: boolean;
  onChange?: () => void;
  sx?: SxProps<Theme>;
}

export default function Checkbox({
  ariaLabel,
  color = 'treadOrange',
  isChecked,
  isDisabled,
  isIntermediate,
  onChange,
  sx,
}: CheckboxProps) {
  const handleChange = useCallback(
    (event: React.MouseEvent) => {
      event.preventDefault();
      event.stopPropagation();
      onChange?.();
    },
    [onChange],
  );

  return (
    <MuiCheckbox
      data-test-id="checkbox-component"
      checked={Boolean(isChecked)}
      disabled={Boolean(isDisabled)}
      indeterminate={Boolean(isIntermediate)}
      onClick={handleChange}
      size="small"
      slotProps={{ input: { 'aria-label': ariaLabel } }}
      sx={[
        (theme) => ({
          [`&.${checkboxClasses.root}`]: { color: theme.brandV2.colors.treadGray6, p: 0 },
          [`&.${checkboxClasses.checked}`]: { color: theme.brandV2.colors[color] },
          [`&.${checkboxClasses.disabled}`]: { pointerEvents: 'auto' },
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    />
  );
}
